export const wizardTranslations = {
  fr: {
    eyebrow: 'Étude gratuite · sans engagement',
    title: 'Votre projet solaire en 3 étapes',
    subtitle: 'Moins d’une minute. Un technicien NOYA vous rappelle sous 48 h pour préparer votre étude.',
    step_of: 'Étape {n} sur {total}',
    steps: {
      building: 'Bâtiment',
      consumption: 'Consommation',
      contact: 'Coordonnées',
      review: 'Récapitulatif',
    },
    next: 'Continuer',
    back: 'Retour',
    edit: 'Modifier',
    step_label: 'Étape {n}',
    summary: {
      title: 'Votre projet',
      empty: 'À compléter',
      bill: 'Facture mensuelle',
      goal: 'Objectif',
    },
    trust: {
      free: 'Étude et visite technique gratuites',
      callback: 'Un technicien vous rappelle sous 48 h',
      commitment: 'Aucun engagement',
    },
    building: {
      title: 'Où souhaitez-vous installer vos panneaux ?',
      house: 'Maison individuelle',
      house_hint: 'Villa, maison avec toit terrasse',
      apartment: 'Immeuble collectif',
      apartment_hint: 'Copropriété, toit partagé',
      commercial: 'Local commercial',
      commercial_hint: 'Boutique, bureau, entreprise',
      industrial: 'Site agricole ou industriel',
      industrial_hint: 'Ferme, forage, usine',
    },
    consumption: {
      title: 'Votre consommation d’électricité',
      bill_label: 'Votre facture moyenne, par mois',
      bill_hint: 'Une facture STEG couvre deux mois : divisez son montant par 2.',
      bill_unit: 'DT / mois',
      need_label: 'Votre objectif principal',
      need_hint: 'Plusieurs choix possibles.',
      steg_label: 'Référence STEG (facultatif)',
      steg_hint: 'En haut de votre facture. Elle nous permet de préparer la visite.',
    },
    bill: {
      r0_180: 'Moins de 180 DT',
      r180_240: '180 – 240 DT',
      r240_350: '240 – 350 DT',
      r350_500: '350 – 500 DT',
      r500_600: '500 – 600 DT',
      r600_1000: '600 – 1 000 DT',
      r1000_plus: 'Plus de 1 000 DT',
    },
    need: {
      reduce: 'Réduire ma facture',
      reduce_hint: 'Produire ce que je consomme le jour',
      backup: 'Rester alimenté pendant les coupures',
      backup_hint: 'Avec des batteries de stockage',
    },
    contact: {
      title: 'Où pouvons-nous vous joindre ?',
      name_label: 'Nom complet',
      name_placeholder: 'Ex. Mohamed Ben Ali',
      phone_label: 'Téléphone',
      phone_placeholder: '22 123 456',
      phone_hint: 'Uniquement pour vous rappeler au sujet de votre projet.',
      governorate_label: 'Gouvernorat',
      governorate_placeholder: 'Choisir…',
    },
    review: {
      eyebrow: 'Dernière étape',
      title: 'Vérifiez votre demande',
      per_month: '/ mois',
      steg: 'Référence STEG',
      name: 'Nom',
      building: 'Bâtiment',
      consumption: 'Consommation',
      contact: 'Contact',
      consent: 'En envoyant, vous acceptez d’être rappelé par NOYA Énergie au sujet de votre projet. Vos données servent uniquement à traiter votre demande.',
      submit: 'Obtenir un devis',
      submitting: 'Envoi en cours…',
    },
    errors: {
      required_choice: 'Choisissez une option pour continuer.',
      name: 'Indiquez votre nom.',
      phone: 'Numéro invalide. Ex. 22 123 456 (numéro étranger : +33 6 12 34 56 78).',
      phone_required: 'Indiquez votre numéro de téléphone.',
      governorate: 'Choisissez votre gouvernorat.',
      submit: 'L’envoi a échoué. Vos réponses sont conservées : réessayez, ou appelez-nous au {phone}.',
    },
    success: {
      title: 'Merci {name}, votre demande est bien reçue !',
      subtitle: 'Voici la suite :',
      step1_title: 'Appel sous 48 h',
      step1_text: 'Un technicien vous appelle pour affiner vos besoins.',
      step2_title: 'Visite technique gratuite',
      step2_text: 'Mesure du toit, de l’orientation et de l’ombrage.',
      step3_title: 'Devis détaillé',
      step3_text: 'Matériel, prix et rentabilité, sans engagement.',
      whatsapp: 'Écrire sur WhatsApp',
      home: 'Retour à l’accueil',
      new_request: 'Nouvelle demande',
    },
  },
  en: {
    eyebrow: 'Free study · no commitment',
    title: 'Your solar project in 3 steps',
    subtitle: 'Less than a minute. A NOYA technician calls you back within 48 hours to prepare your study.',
    step_of: 'Step {n} of {total}',
    steps: {
      building: 'Building',
      consumption: 'Consumption',
      contact: 'Contact',
      review: 'Summary',
    },
    next: 'Continue',
    back: 'Back',
    edit: 'Edit',
    step_label: 'Step {n}',
    summary: {
      title: 'Your project',
      empty: 'To be completed',
      bill: 'Monthly bill',
      goal: 'Goal',
    },
    trust: {
      free: 'Free study and technical visit',
      callback: 'A technician calls you within 48 h',
      commitment: 'No commitment',
    },
    building: {
      title: 'Where would you like to install your panels?',
      house: 'Detached house',
      house_hint: 'Villa, house with a flat roof',
      apartment: 'Apartment building',
      apartment_hint: 'Shared roof',
      commercial: 'Commercial premises',
      commercial_hint: 'Shop, office, company',
      industrial: 'Farm or industrial site',
      industrial_hint: 'Farm, borehole, factory',
    },
    consumption: {
      title: 'Your electricity consumption',
      bill_label: 'Your average bill, per month',
      bill_hint: 'A STEG bill covers two months: divide its amount by 2.',
      bill_unit: 'DT / month',
      need_label: 'Your main goal',
      need_hint: 'You can pick both.',
      steg_label: 'STEG reference (optional)',
      steg_hint: 'At the top of your bill. It helps us prepare the visit.',
    },
    bill: {
      r0_180: 'Under 180 DT',
      r180_240: '180 – 240 DT',
      r240_350: '240 – 350 DT',
      r350_500: '350 – 500 DT',
      r500_600: '500 – 600 DT',
      r600_1000: '600 – 1,000 DT',
      r1000_plus: 'Over 1,000 DT',
    },
    need: {
      reduce: 'Lower my bill',
      reduce_hint: 'Produce what I use during the day',
      backup: 'Keep power during outages',
      backup_hint: 'With storage batteries',
    },
    contact: {
      title: 'How can we reach you?',
      name_label: 'Full name',
      name_placeholder: 'e.g. Mohamed Ben Ali',
      phone_label: 'Phone',
      phone_placeholder: '22 123 456',
      phone_hint: 'Only used to call you back about your project.',
      governorate_label: 'Governorate',
      governorate_placeholder: 'Choose…',
    },
    review: {
      eyebrow: 'Last step',
      title: 'Check your request',
      per_month: '/ month',
      steg: 'STEG reference',
      name: 'Name',
      building: 'Building',
      consumption: 'Consumption',
      contact: 'Contact',
      consent: 'By sending, you agree to be called back by NOYA Énergie about your project. Your data is only used to handle your request.',
      submit: 'Get a quote',
      submitting: 'Sending…',
    },
    errors: {
      required_choice: 'Pick an option to continue.',
      name: 'Please enter your name.',
      phone: 'Invalid number. e.g. 22 123 456 (foreign number: +33 6 12 34 56 78).',
      phone_required: 'Please enter your phone number.',
      governorate: 'Please choose your governorate.',
      submit: 'Sending failed. Your answers are kept: try again, or call us at {phone}.',
    },
    success: {
      title: 'Thank you {name}, we received your request!',
      subtitle: 'What happens next:',
      step1_title: 'Call within 48 h',
      step1_text: 'A technician calls you to refine your needs.',
      step2_title: 'Free technical visit',
      step2_text: 'We measure the roof, orientation and shading.',
      step3_title: 'Detailed quote',
      step3_text: 'Equipment, price and payback, no commitment.',
      whatsapp: 'Message us on WhatsApp',
      home: 'Back to home',
      new_request: 'New request',
    },
  },
};

/** Arabic shown in parentheses after the building choices and the consumption title, whatever the page language. */
export const wizardArabic: Record<string, string> = {
  'wizard.building.house': 'منزل فردي',
  'wizard.building.apartment': 'عمارة سكنية',
  'wizard.building.commercial': 'محل تجاري',
  'wizard.building.industrial': 'موقع فلاحي أو صناعي',
  'wizard.consumption.title': 'استهلاكك للكهرباء',
};
